import ProductCardsGridComponent from "./product-cards-grid-component";
import ProductCardsGridConfig from "./product-cards-grid-config";
import ProductCardsGridAdvancedConfig from "./product-cards-grid-advanced-config";

export default {
  ProductCardsGridComponent,
  ProductCardsGridConfig,
  ProductCardsGridAdvancedConfig
};
